<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    text?: string
    severity?: 'info' | 'warning'
    showIcon?: boolean
  }>(),
  {
    text: undefined,
    severity: 'warning',
    showIcon: true,
  }
)

const iconSrc = computed(() => {
  switch (props.severity) {
    case 'info':
      return '/images/icons/info.svg'
    case 'warning':
      return '/images/icons/warning-alert.svg'
  }
})
</script>

<template>
  <div
    class="my-4 flex flex-row items-start gap-3 rounded bg-mcd-neutralGrey p-4"
    data-test="product-alert"
  >
    <img v-if="showIcon" class="h-8 w-8 grayscale" :src="iconSrc" :alt="severity" />
    <p
      v-if="text"
      v-dompurify-html="text"
      class="prose w-full max-w-none self-center text-xs md:text-sm"
    ></p>
    <div v-else>
      <slot />
    </div>
  </div>
</template>
